import React from 'react';
import '../../../../styles/components/auction-track.scss';
import { Check, X, Clock, Download, FileText, ArrowLeft } from 'lucide-react';
import i18n from '../../../../i18n';
import HeaderBanner from '../../../common/HeaderBanner';
import { SideBar } from '../../sidebar';
import { getAuctionTracking } from './services/myBidsServices';
import { withRouter } from '../../../../hoc/withRouter';
import { formatDate } from '../../../../utils/common';
import StatusBadge from '../../../common/StatusBadge';
import { AUCTION_STATUS } from '../../../../constants/status';
import { apiUrl } from '../../../../constants/global';
import { getLoggedUser } from '../../../../state/user';

const user = getLoggedUser();

class AuctionTracking extends React.Component {
  constructor() {
    super();
    this.state = {
      auctionId: null,
      isLoading: false,
      auction: {},
      tracking: [
        // { label: 'Site Visit Start', date: 'Oct 16, 2023 - 09:00 AM', status: 'completed' },
        // { label: 'Site Visit End', date: 'Oct 16, 2023 - 11:00 AM', status: 'completed' },
        // { label: 'Auction Start', date: 'Oct 17, 2023 - 09:00 AM', status: 'completed' },
        // { label: 'Auction End', date: 'Oct 17, 2023 - 10:00 AM', status: 'completed' },
        // { label: 'Auction Won', date: 'Oct 17, 2023 - 10:05 AM', status: 'completed' },
        // { label: 'Client Approved', date: '', status: 'in-progress' },
        // { label: 'Client Rejected', date: '', status: 'in-progress' },
        // { label: 'Finance Approved', date: 'Rejected - Oct 20, 2023', status: 'rejected' },
        // { label: 'Auction Completed', date: '', status: 'pending' },
      ],
    };
  }
  componentDidMount() {
    window.scrollTo(0, 0);
    const { auctionId } = this.props.params;

    this.setState({ auctionId }, () => {
      this.loadAuctionTracking();
    });
  }

  async loadAuctionTracking() {
    this.setState({ isLoading: true });
    let { auctionId } = this.state;

    let response = await getAuctionTracking({ auctionId });
    if (response.success) {
      let auction = response.data;
      const tracking = auction.tracking || {};

      const trackingItems = [
        tracking.site_visit_start && {
          label: i18n.t('site_visit_start'),
          date: formatDate(tracking.site_visit_start.date),
          status: tracking.site_visit_start.status,
        },
        tracking.site_visit_end && {
          label: i18n.t('site_visit_end'),
          date: formatDate(tracking.site_visit_end.date),
          status: tracking.site_visit_end.status,
        },
        tracking.auction_started && {
          label: i18n.t('auction_start'),
          date: formatDate(tracking.auction_started.date),
          status: tracking.auction_started.status,
        },
        tracking.auction_ended && {
          label: i18n.t('auction_end'),
          date: formatDate(tracking.auction_ended.date),
          status: tracking.auction_ended.status,
        },
        tracking.result && {
          label: i18n.t('auction_won'),
          date: formatDate(tracking.result.date),
          status: tracking.result.status,
        },
        tracking.client_approved && {
          label: i18n.t('client_approval'),
          date: formatDate(tracking.client_approved.date),
          status: tracking.client_approved.status,
        },
        tracking.client_rejected && {
          label: i18n.t('client_rejected'),
          date: formatDate(tracking.client_rejected.date),
          status: tracking.client_rejected.status,
        },
        tracking.bidder_payment && {
          label: i18n.t('payment'),
          date: formatDate(tracking.bidder_payment.date),
          status: tracking.bidder_payment.status,
        },
        tracking.finance_approved && {
          label: i18n.t('fm_approved_on'),
          date: formatDate(tracking.finance_approved.date),
          status: tracking.finance_approved.status,
        },
        tracking.auction_completed && {
          label: i18n.t('auction_completed'),
          date: formatDate(tracking.auction_completed.date),
          status: tracking.auction_completed.status,
        },
      ].filter(Boolean);

      this.setState({
        auction,
        tracking: trackingItems,
        isLoading: false,
      });
    }
    this.setState({ isLoading: false });
  }

  renderIcon(status) {
    switch (status) {
      case 'completed':
        return <Check size={16} />;
      case 'in-progress':
        return <X size={16} />;
      case 'rejected':
        return <X size={16} />;
      case 'pending':
      default:
        return <Clock size={16} />;
    }
  }
  render() {
    const { tracking, isLoading, auction } = this.state;
    const isArabic = i18n.language === 'ar';
    return (
      <React.Fragment>
        <HeaderBanner
          title={i18n.t('auction_tracker')}
          subtitle={i18n.t('auction_tracker_subtitle')}
        />
        <section className="mt-5">
          <div className="container">
            <div className="row">
              <div className="col-xl-3 col-lg-12 col-md-12">
                {!this.state.hideSidebar && <SideBar />}
              </div>
              <div
                className={
                  this.state.hideSidebar
                    ? 'col-xl-12 col-lg-12 col-md-12'
                    : 'col-xl-9 col-lg-12 col-md-12'
                }
              >
                <div className="card">
                  <div className="card-header">
                    <div className="expand-dashboard">
                      <span
                        style={{ fontSize: '1rem', marginRight: '0.5rem', cursor: 'pointer' }}
                        onClick={() => {
                          this.setState({
                            hideSidebar: !this.state.hideSidebar,
                          });
                        }}
                      >
                        {this.state.hideSidebar && <i className="icon-size-actual"></i>}
                        {!this.state.hideSidebar && <i className="icon-size-fullscreen"></i>}
                      </span>
                    </div>
                    <div className="header-action">
                      {/* Back Button */}
                      <button
                        className="btn-back"
                        onClick={() => this.props.navigate(`/my_auctions`)}
                      >
                        <ArrowLeft size={18} className="icon" />
                        <span>{i18n.t('back')}</span>
                      </button>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="auction-tracking" dir={isArabic ? 'rtl' : 'ltr'}>
                      <div className="content-grid">
                        {/* LEFT COLUMN - Timeline, Remarks, etc. */}
                        <div className="left-column">
                          <div className="card-list progress-timeline">
                            <h2>{i18n.t('auction_progress_timeline')}</h2>

                            <div className="timeline">
                              {isLoading && tracking.length === 0 ? (
                                //  Skeleton Loader
                                <>
                                  {[...Array(5)].map((_, index) => (
                                    <div key={index} className="timeline-item skeleton-t2">
                                      <div className="timeline-icon skeleton-icon"></div>
                                      <div className="timeline-content">
                                        <div className="skeleton-line title"></div>
                                        <div className="skeleton-line date"></div>
                                      </div>
                                    </div>
                                  ))}
                                </>
                              ) : (
                                //  Normal Timeline
                                tracking.map((item, index) => (
                                  <div key={index} className={`timeline-item ${item.status}`}>
                                    <div className={`timeline-icon ${item.status}`}>
                                      {this.renderIcon(item.status)}
                                    </div>
                                    <div className="timeline-content">
                                      <h3>{item.label}</h3>
                                      <p>
                                        {item.date ||
                                          (item.status === 'in-progress'
                                            ? 'In progress...'
                                            : item.status === 'rejected'
                                            ? 'Rejected'
                                            : item.status)}
                                      </p>
                                    </div>
                                  </div>
                                ))
                              )}
                            </div>
                          </div>

                          {(auction.client_approved_at || auction.finance_approved_at) && (
                            <div className="card-list remarks">
                              <h2>{i18n.t('remarks_notes')}</h2>

                              {auction.finance_approved_at && (
                                <div className="note-item">
                                  <div className="note-content">
                                    <p>{i18n.t('payment_completed_note')}</p>
                                    <span className="note-meta">
                                      Client - {formatDate(auction.finance_approved_at)}
                                    </span>
                                  </div>
                                </div>
                              )}
                              {auction.client_approved_at && (
                                <div className="note-item">
                                  <div className="note-content">
                                    <p>{i18n.t('client_approved_note')}</p>
                                    <span className="note-meta">
                                      Admin - {formatDate(auction.client_approved_at)}
                                    </span>
                                  </div>
                                </div>
                              )}
                            </div>
                          )}
                        </div>

                        {/* RIGHT COLUMN - Auction Info, Status, Documents */}
                        <div className="right-column">
                          <div className="card-list auction-info">
                            <h2>{i18n.t('auction_information')}</h2>

                            {isLoading ? (
                              //  Skeleton loader
                              <div className="info-grid">
                                {[...Array(6)].map((_, i) => (
                                  <div className="info-item" key={i}>
                                    <div className="skeleton-label skeleton-t3" />
                                    <div className="skeleton-text skeleton-t3" />
                                  </div>
                                ))}
                              </div>
                            ) : (
                              //  Loaded data
                              <div className="info-grid">
                                <div className="info-item">
                                  <label>{i18n.t('auction_title_id')}</label>
                                  <p>
                                    {isArabic ? auction.title_ar : auction.title} / MZAD{' '}
                                    {auction.id}
                                  </p>
                                </div>
                                <div className="info-item">
                                  <label>{i18n.t('client_name')}</label>
                                  <p>
                                    {isArabic
                                      ? auction.organization_relation?.organization_name_ar
                                      : auction.organization_relation?.organization_name}
                                  </p>
                                </div>
                                <div className="info-item">
                                  <label>{i18n.t('group_name')}</label>
                                  <p>
                                    {isArabic
                                      ? auction.group_relation?.group_name_ar
                                      : auction.group_relation?.group_name}
                                  </p>
                                </div>
                                {auction.location && (
                                  <div className="info-item">
                                    <label>{i18n.t('site_location')}</label>
                                    <p>{isArabic ? auction.location_ar : auction.location}</p>
                                  </div>
                                )}

                                <div className="info-item">
                                  <label>{i18n.t('auciton_status')}</label>
                                  <p>
                                    <StatusBadge status={i18n.t(AUCTION_STATUS[auction.status])} />
                                  </p>
                                </div>
                                <div className="info-item">
                                  <label>{i18n.t('description')}</label>
                                  <p>{isArabic ? auction.description_ar : auction.description}</p>
                                </div>
                              </div>
                            )}
                          </div>

                          <div className="card-list status-summary">
                            <h2>{i18n.t('status_summary')}</h2>
                            {isLoading ? (
                              // Skeleton loader
                              <div className="progress-section skeleton-t3">
                                <div className="progress-header">
                                  <span
                                    className="skeleton-box"
                                    style={{ width: '120px', height: '16px' }}
                                  ></span>
                                  <span
                                    className="skeleton-box"
                                    style={{ width: '40px', height: '16px' }}
                                  ></span>
                                </div>
                                <div className="progress-bar">
                                  <div
                                    className="skeleton-box"
                                    style={{ width: '100%', height: '8px', borderRadius: '4px' }}
                                  ></div>
                                </div>
                                <p
                                  className="skeleton-box"
                                  style={{ width: '60%', height: '14px', marginTop: '8px' }}
                                ></p>
                              </div>
                            ) : (
                              // Actual progress section
                              <div className="progress-section">
                                <div className="progress-header">
                                  <span>{i18n.t('overall_progress')}</span>
                                  <span className="percentage">
                                    {Math.round(
                                      (tracking.filter(
                                        (item) => item.status?.toLowerCase() === 'completed'
                                      ).length /
                                        tracking.length) *
                                        100
                                    )}
                                    %
                                  </span>
                                </div>

                                <div className="progress-bar">
                                  <div
                                    className="progress-fill"
                                    style={{
                                      width: `${Math.round(
                                        (tracking.filter(
                                          (item) => item.status?.toLowerCase() === 'completed'
                                        ).length /
                                          tracking.length) *
                                          100
                                      )}%`,
                                    }}
                                  ></div>
                                </div>

                                <p className="progress-text">
                                  {i18n.t('progress_text', {
                                    completed: tracking.filter(
                                      (item) => item.status?.toLowerCase() === 'completed'
                                    ).length,
                                    total: tracking.length,
                                  })}
                                </p>
                              </div>
                            )}
                          </div>

                          {auction.client_approved_at && (
                            <div className="card-list documents">
                              <h2>{i18n.t('documents_attachments')}</h2>

                              <div className="document-list">
                                <div className="document-item">
                                  <div className="doc-icon pdf">
                                    <FileText size={20} />
                                  </div>
                                  <div className="doc-info">
                                    <h4>{i18n.t('invoice')}</h4>
                                    {/* <p>Oct 22, 2023</p> */}
                                  </div>
                                  <a
                                    href={
                                      apiUrl +
                                      'my_winnings/pdf?' +
                                      new URLSearchParams({
                                        id: user.id,
                                        auction: auction.id, // or row.id depending on your data
                                      }).toString()
                                    }
                                    target="_blank"
                                    rel="noreferrer"
                                    className="download-btn"
                                    title="Download Invoice"
                                  >
                                    <Download size={18} />
                                  </a>
                                </div>
                                {/* 
                              <div className="document-item">
                                <div className="doc-icon docx">
                                  <File size={20} />
                                </div>
                                <div className="doc-info">
                                  <h4>Approval_Form.docx</h4>
                                  <p>450 KB - Oct 21, 2023</p>
                                </div>
                                <button className="download-btn">
                                  <Download size={18} />
                                </button>
                              </div> */}
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}
export default withRouter(AuctionTracking);
